{
  "league": "Gridiron League",
  "opponentUniform": {
    "jersey": "#f2f3f5",
    "numbers": "#2f3846",
    "helmet": "#c4c9d0",
    "facemask": "#2f3846",
    "pants": "#c4c9d0",
    "stripe": "#2f3846"
  },
  "opponents": [
    {
      "id": "granite",
      "name": "Granite",
      "accent": "#6f7782"
    },
    {
      "id": "tundra",
      "name": "Tundra",
      "accent": "#5fa8d3"
    },
    {
      "id": "monsoon",
      "name": "Monsoon",
      "accent": "#2e7d6b"
    },
    {
      "id": "dune",
      "name": "Dune",
      "accent": "#c48a3f"
    },
    {
      "id": "summit",
      "name": "Summit",
      "accent": "#7a5ea8"
    },
    {
      "id": "reef",
      "name": "Reef",
      "accent": "#1f9fb0"
    },
    {
      "id": "ember",
      "name": "Ember",
      "accent": "#c4472f"
    }
  ]
}
